import React, { useState } from 'react';
import Modal from '../../Atoms/Modal/Modal';
import styles from './EventInfoModal.module.scss';
import calendarIcon from '../../../assets/Imagess/calendar-black.svg';
import clockIcon from '../../../assets/Imagess/clock-black.svg';
import locationIcon from '../../../assets/Imagess/location-pin-black.svg';
import Buttons from '../../Atoms/Buttons/Buttons';
import { useNavigate } from 'react-router-dom';
import arrowLeft from '../../../assets/Imagess/arrow-circle-left.svg';
import arrowRight from '../../../assets/Imagess/arrow-circle-right.svg';
import noImageFound from '../../../assets/Imagess/no-image-found.jpg';
import moment from 'moment';
import { isEmpty } from 'lodash';
import he from 'he';
import { sanitizeAndValidateUrl } from '../../../app/helpers/sanitizeAndValidateUrl';

const EventInfoModal = ({ event, handleOnClose, setShowDeletePopup }) => {
  const navigate = useNavigate();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const images = [event?.image1, event?.image2, event?.image3];

  const handlePreviousImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const decodedHTML = event ? he.decode(event?.eventText_AR) : '';

  return (
    <Modal
      onClose={handleOnClose}
      width="559px"
      modalInnerContainerStyle={{ padding: '0px', gap: '0px' }}
    >
      <div className={styles['image-container']}>
        <img
          src={arrowLeft}
          className={styles['arrow-left']}
          onClick={handlePreviousImage}
        />
        <img
          src={sanitizeAndValidateUrl(
            `${event?.url}${images[currentImageIndex]}`
          )}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = noImageFound;
          }}
          className={styles['modal-image']}
        />
        <img
          src={arrowRight}
          className={styles['arrow-right']}
          onClick={handleNextImage}
        />
      </div>
      <div className={styles['title-container']}>
        <p className={styles['title']}>{event?.title_AR}</p>
      </div>
      <div className={styles['info-container']}>
        <p className={styles['category-name']}>{event?.category_AR}</p>
        <div className={styles['date-time-container']}>
          <div className={styles['date-time-item']}>
            <img src={calendarIcon} />
            {moment(event?.eventDate).format('DD/MM/YYYY')}
          </div>
          <div className={styles['date-time-item']}>
            {moment(event?.eventDate).format('h:mm A')}
            <img src={clockIcon} />
          </div>
        </div>
        <div
          className={styles['date-time-container']}
          style={{ marginTop: '16px', marginBottom: '16px' }}
        >
          <div className={styles['date-time-item']}>
            <p>{!isEmpty(event?.locationLink) ? event?.locationLink : '-'}</p>
            <img src={locationIcon} />
          </div>
        </div>
        <div className={styles['text-container']}>
          <div className={styles['description']}>
            <p
              className={styles['text']}
              dangerouslySetInnerHTML={{ __html: decodedHTML }}
            />
          </div>
        </div>
        <div className={styles['button-container']}>
          <Buttons
            text="تعديل"
            color="#0DA06E"
            rounded={true}
            style={{ width: '100%' }}
            type="submit"
            handleOnClick={() => navigate(`/home/edit-event/${event?.eventId}`)}
          />
          <Buttons
            text="حذف"
            color="#D72222"
            rounded={true}
            style={{ width: '100%' }}
            type="submit"
            handleOnClick={() => {
              handleOnClose();
              setShowDeletePopup(true);
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default EventInfoModal;
